import { dcTag } from './dcTag.model';

export class BaseCoreObject {
  /// <summary>
  /// Name of the entity which is present inside the hierarchy
  /// </summary>
  public Name: string;

  /// <summary>
  /// Unique for a specific enity
  /// </summary>
  public ObjectID: number;

  /// <summary>
  /// List of tags
  /// </summary>
  public Tags: dcTag[];

  /// <summary>
  /// UniqueID to be unique across entire system
  /// </summary>
  public UniqueID: number;

  /// <summary>
  /// Description
  /// </summary>
  public Description: string;
}
